import WindowLocation from 'helpers/windowLocation'

class Environment {
  static isProduction () {
    return APP_ENV === 'production' // eslint-disable-line no-undef
  }

  static isStaging () {
    return APP_ENV === 'staging' // eslint-disable-line no-undef
  }

  static isQA () {
    return APP_ENV === 'qa' // eslint-disable-line no-undef
  }

  static isQA2 () {
    return APP_ENV === 'qa2' // eslint-disable-line no-undef
  }

  static isDevelopment () {
    return APP_ENV === 'development' // eslint-disable-line no-undef
  }

  static name () {
    return APP_ENV // eslint-disable-line no-undef
  }

  static goRthServiceURL () {
    return GO_RTH_SERVICE_URL || 'https://localhost:3000' // eslint-disable-line no-undef
  }

  static backendApiURL () {
    const clientHostname = WindowLocation.hostname()

    if (clientHostname.match(/tr-dev.net$/)) {
      return 'https://qa2-diagnostics-api.tranehome.com'
    } else if (clientHostname.match(/tr-qa.net$/)) {
      return 'https://qa-diagnostics-api.tranehome.com'
    } else if (clientHostname.match(/tr-staging.net$/)) {
      return 'https://stage1-diagnostics-api.tranehome.com'
    } else if (clientHostname.match(/tranehome.net$/)) {
      return 'https://diagnostics-api.tranehome.com'
    }

    if (clientHostname === 'localhost' && WindowLocation.port() === '8090') {
      return 'http://localhost:8090'
    }

    const regex = /^(.*?)\./
    const backendHostname = 'https://' + clientHostname.replace(regex, '$1-api.')

    return backendHostname || 'https://localhost:3000'
  }

  static signOutURL () {
    return SIGN_OUT_URL || 'https://localhost:3000' // eslint-disable-line no-undef
  }

  static isAWSCognito () {
    return USE_AWS_COGNITO === true // eslint-disable-line no-undef
  }

  static webSocketURL () {
    return WEBSOCKET_URL || 'wss://dwa-ws.tr-dev.net' // eslint-disable-line no-undef
  }

  static chatbotWebSocketURL () {
    return CHATBOT_WEBSOCKET_URL || 'wss://tech-assistant-socket-v2.tr-dev.net' // eslint-disable-line no-undef
  }
}

export default Environment
